import { observer } from 'mobx-react-lite'
import { useFormFieldMapping } from 'app/components/form-field-mapping/useFormFieldMapping'
import { FormFieldMappingPageShadcnComponent } from 'app/components/form-field-mapping/FormFieldMappingPageShadcnComponent'

export default observer(function Forms(): React.ReactElement {
  const props = useFormFieldMapping()
  return <FormFieldMappingPageShadcnComponent {...props} />
})
